export default __webpack_public_path__ + "static/12-2--779cb4fe62b9fc639d605da0b8cf8e93.png";